// @ts-ignore
function n(e) {
  // @ts-ignore
  this.init(e || {});
}
n.prototype = {
  // @ts-ignore
  init: function (e) {
    // @ts-ignore
    this.phase = e.phase || 0;
    // @ts-ignore
    this.offset = e.offset || 0;
    // @ts-ignore
    this.frequency = e.frequency || 0.001;
    // @ts-ignore
    this.amplitude = e.amplitude || 1;
  },
  update: function () {
    // @ts-ignore
    this.phase += this.frequency;
    // @ts-ignore
    return (this.offset + Math.sin(this.phase) * this.amplitude);
  },
  value: function () {
    // @ts-ignore
    return this.offset + Math.sin(this.phase) * this.amplitude;
  },
};

// @ts-ignore
function Line(e) {
  // @ts-ignore
  this.init(e || {});
}

Line.prototype = {
  // @ts-ignore
  init: function (e) {
    // @ts-ignore
    this.spring = e.spring + 0.1 * Math.random() - 0.05;
    // @ts-ignore
    this.friction = E.friction + 0.01 * Math.random() - 0.005;
    // @ts-ignore
    this.nodes = [];
    for (let n = 0; n < E.size; n++) {
      const t = new Node();
      // Initialize nodes at center of screen if pos is not set yet
      t.x = pos.x || window.innerWidth / 2;
      t.y = pos.y || window.innerHeight / 2;
      // @ts-ignore
      this.nodes.push(t);
    }
  },
  update: function () {
    // @ts-ignore
    let e = this.spring;
    // @ts-ignore
    let t = this.nodes[0];
    // @ts-ignore
    t.vx += (pos.x - t.x) * e;
    // @ts-ignore
    t.vy += (pos.y - t.y) * e;
    
    // @ts-ignore
    for (let i = 0, a = this.nodes.length; i < a; i++) {
      // @ts-ignore
      t = this.nodes[i];
      if (0 < i) {
        // @ts-ignore
        const n = this.nodes[i - 1];
        // @ts-ignore
        t.vx += (n.x - t.x) * e;
        // @ts-ignore
        t.vy += (n.y - t.y) * e;
        // @ts-ignore
        t.vx += n.vx * E.dampening;
        // @ts-ignore
        t.vy += n.vy * E.dampening;
      }
      // @ts-ignore
      t.vx *= this.friction;
      // @ts-ignore
      t.vy *= this.friction;
      t.x += t.vx;
      t.y += t.vy;
      e *= E.tension;
    }
  },
  draw: function () {
    // @ts-ignore
    let n = this.nodes[0].x;
    // @ts-ignore
    let i = this.nodes[0].y;
    
    // @ts-ignore
    ctx.beginPath();
    // @ts-ignore
    ctx.moveTo(n, i);
    
    // @ts-ignore
    for (let a = 1, o = this.nodes.length - 2; a < o; a++) {
      // @ts-ignore
      const e = this.nodes[a];
      // @ts-ignore
      const t = this.nodes[a + 1];
      n = 0.5 * (e.x + t.x);
      i = 0.5 * (e.y + t.y);
      // @ts-ignore
      ctx.quadraticCurveTo(e.x, e.y, n, i);
    }
    
    // @ts-ignore
    const e = this.nodes[this.nodes.length - 2];
    // @ts-ignore
    const t = this.nodes[this.nodes.length - 1];
    // @ts-ignore
    ctx.quadraticCurveTo(e.x, e.y, t.x, t.y);
    // @ts-ignore
    ctx.stroke();
    // @ts-ignore
    ctx.closePath();
  },
};

// @ts-ignore
function onMousemove(e) {
  function o() {
    lines = [];
    for (let i = 0; i < E.trails; i++) {
      lines.push(new Line({ spring: 0.45 + (i / E.trails) * 0.025 }));
    }
  }
  
  // @ts-ignore
  function c(event) {
    if (event.touches) {
      // @ts-ignore
      pos.x = event.touches[0].pageX;
      // @ts-ignore
      pos.y = event.touches[0].pageY;
    } else {
      // @ts-ignore
      pos.x = event.clientX;
      // @ts-ignore
      pos.y = event.clientY;
    }
    event.preventDefault();
  }
  
  // @ts-ignore
  function l(event) {
    // @ts-ignore
    if (event.touches.length === 1) {
      pos.x = event.touches[0].pageX;
      pos.y = event.touches[0].pageY;
    }
  }
  
  document.removeEventListener("mousemove", onMousemove);
  document.removeEventListener("touchstart", onMousemove);
  document.addEventListener("mousemove", c);
  document.addEventListener("touchmove", c);
  document.addEventListener("touchstart", l);
  c(e);
  o();
  // Don't call render() here, it will be called from the animation frame
}

function render() {
  // @ts-ignore
  if (ctx && ctx.running) {
    // @ts-ignore
    ctx.globalCompositeOperation = "source-over";
    // @ts-ignore
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    // @ts-ignore
    ctx.globalCompositeOperation = "lighter";
    // @ts-ignore
    ctx.strokeStyle = `hsla(${Math.round(f.update())},100%,50%,0.025)`;
    // @ts-ignore
    ctx.lineWidth = 10;
    
    for (let t = 0; t < E.trails; t++) {
      // @ts-ignore
      const line = lines[t];
      if (line) {
        line.update();
        line.draw();
      }
    }
    
    // @ts-ignore
    ctx.frame = (ctx.frame || 0) + 1;
    window.requestAnimationFrame(render);
  }
}

function resizeCanvas() {
  // @ts-ignore
  if (ctx && ctx.canvas) {
    // @ts-ignore
    ctx.canvas.width = window.innerWidth - 20;
    // @ts-ignore
    ctx.canvas.height = window.innerHeight;
  }
}

// @ts-ignore
let ctx = null;
// @ts-ignore
let f = null;
const pos = { x: 0, y: 0 };
// @ts-ignore
let lines = [];
const E = {
  debug: true,
  friction: 0.5,
  trails: 80,
  size: 50,
  dampening: 0.025,
  tension: 0.99,
};

function Node() {
  this.x = 0;
  this.y = 0;
  this.vy = 0;
  this.vx = 0;
}

export const renderCanvas = function () {
  // @ts-ignore
  const canvas = document.getElementById("canvas");
  if (!canvas) {
    console.error("Canvas element not found");
    return;
  }
  
  // @ts-ignore
  ctx = canvas.getContext("2d");
  if (!ctx) {
    console.error("Could not get canvas context");
    return;
  }
  
  ctx.running = true;
  ctx.frame = 1;
  
  // Initialize pos to center of screen
  pos.x = window.innerWidth / 2;
  pos.y = window.innerHeight / 2;
  
  f = new n({
    phase: Math.random() * 2 * Math.PI,
    amplitude: 85,
    frequency: 0.0015,
    offset: 285,
  });
  
  // Initialize lines
  lines = [];
  for (let i = 0; i < E.trails; i++) {
    lines.push(new Line({ spring: 0.45 + (i / E.trails) * 0.025 }));
  }
  
  document.addEventListener("mousemove", onMousemove);
  document.addEventListener("touchstart", onMousemove);
  document.body.addEventListener("orientationchange", resizeCanvas);
  window.addEventListener("resize", resizeCanvas);
  
  window.addEventListener("focus", () => {
    // @ts-ignore
    if (ctx && !ctx.running) {
      // @ts-ignore
      ctx.running = true;
      render();
    }
  });
  
  window.addEventListener("blur", () => {
    // @ts-ignore
    if (ctx) {
      ctx.running = false;
    }
  });
  
  resizeCanvas();
  // Start the render loop
  render();
};